(function () {
  'use strict';

  angular
    .module('itecAdministracio.usuaris.main')
    .config(config);

  function config($stateProvider, $urlRouterProvider) {

    $stateProvider
      .state('usuaris.main', {
        url: '/',
        params: {
          tipus: 0,
          nom: '',
          submenuInfo: {
            visible: true,
            left: {
              visible: true,
              visibleMenu: true,
              collapsable: true,
              collapsed: false,
              name: 'DEFAULT_USUARIS',
              nameCollapsed: 'DEFAULT_USUARIS',
              icon: 'view_list',
              columns: 4,
              columnsCollapsed: 0
            },
            content: {
              visible: true,
              collapsable: true,
              collapsed: true,
              columnsCollapsed: 0,
              menu: {
                minColumns: 3,
                minOptions: 2
              },
              dynamicMenu: {
                minColumns: 3,
                minOptions: 2
              }
            },
            right: {
              visible: false,
              visibleMenu: false,
            }
          }
        },
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(permisosUsuarisHeaderSubmenuLinksValue) {
                return permisosUsuarisHeaderSubmenuLinksValue;
              }
            }
          },
          'leftSide': {
            templateUrl: 'usuaris/main/llista/llista.tpl.html',
            controller: 'UsuarisMainLlistaCtrl',
            controllerAs: 'ctrl',
            resolve: {
                  llistaentitats:function(EntitatFactory,$rootScope) {
                    if (!angular.isUndefined($rootScope.permisos) && $rootScope.permisos.ROL.read)
                    {
                      return EntitatFactory.getAll().catch(function(){});
                    }
                    else{
                      return undefined;
                    }
                  }
            }
          },
          breadcrumb: 'DEFAULT_USUARIS'

        }
      })
      .state('usuaris.main.submain', {
        url: '{idUsuari:[0-9]{0,32}}',
        abstract: true,
        views: {
          'content@usuaris': {
            templateUrl: 'shared/submain/submain.tpl.html'
          }
        },
        breadcrumb: {
          dynamicText: '{{breadcrumbText}}',
          stateName: 'usuaris.main.submain.dades',
          textParam: {paramName: 'label', paramValue: '{{usuariData.data.username}}'}
        },
        resolve: {
   /*       usuariData: function(UsuariFactory, $stateParams) {
            if ($stateParams.isNew){
              return {};
            }
            else if (!angular.isUndefined($stateParams.idUsuari)
                      && $stateParams.idUsuari !== null
                      && $stateParams.idUsuari) {
              return UsuariFactory.get($stateParams.idUsuari).catch(function(){});
            }
            else {
              return {};
            }
          },*/
          breadcrumbText: function($stateParams){
            if (angular.isUndefined($stateParams.idUsuari) || $stateParams.idUsuari === '') {
              return 'BREADCRUMB_FORMULARI_CREACIO';
            }
            else {
              return 'BREADCRUMB_LABEL';
            }
          }
        }
      });
  }
}());
